// extracted by mini-css-extract-plugin
export default {"btnSort":"TableSort-module_btnSort__RI9y3_"};